/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
import { AxiosPromise } from 'axios';
import api from './api';
import { TicketOrdersFilter, Filters, TicketBlock } from '../interfaces/ticket';

interface Relatorio {
  id: number;
  created_at: string;
  status: string;
  status_display: string;
  updated_at: string;
  file: string;
  json_params: any;
  file_type: string;
  report_type_display: string;
}

const ConvertArrayFilterToObject = (
  filters: Filters = {},
): TicketOrdersFilter => {
  try {
    const object = filters.reduce(
      (obj: any, item: any) => ({ ...obj, ...item }),
      {},
    );
    return object;
  } catch (err) {
    return {};
  }
};

const SerializeFilters = (filters: any): string => {
  const str = [];
  for (const p in filters) {
    if (filters.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(filters[p])}`);
    }
  }
  return str.join('&');
};

class TicketService {
  getOrders = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/ticket/orders/'
      : `api/pjtacom/ticket/orders/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getCards = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/ticket/'
      : `api/pjtacom/ticket/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getCardsDetail = (filters?: Filters, code?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? `api/pjtacom/ticket/${code}/`
      : `api/pjtacom/ticket/${code}/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  blockCards = (code: string, data: TicketBlock): AxiosPromise => {
    const url = `api/pjtacom/ticket/blocked/${code}/`;
    return api.post(url, data);
  };

  createOrder = (data: any): AxiosPromise => {
    const url = 'api/pjtacom/ticket/orders/';
    return api.post(url, data);
  };

  getTicketOrderReport = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };

    const url = `api/pjtacom/report/order-ticket?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getTicketBlocked = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/ticket/blocked/'
      : `api/pjtacom/ticket/blocked/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getTicketBlockedReport = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/blocked-not-duplicate-ticket?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getTicketReportTicket = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/ticket?${SerializeFilters(
      convertedFilters,
    )}`;
    console.log({ url });
    return api.get(url, headers);
  };

  getTicketReplaced = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/ticket/replace/'
      : `api/pjtacom/ticket/replace/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getTicketReplacedReport = (
    filters?: Filters,
    type?: string,
  ): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/replace-tickets?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getTicketReportBalance = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/analytic-balance?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getNoOrdersReport = (filters?: Filters, type?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/ticket?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getTicketExtractRecharge = (
    filters?: Filters,
    type?: string,
  ): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);

    const headers: any =
      type === 'csv' ? null : { responseType: 'arraybuffer' };
    const url = `api/pjtacom/report/extract-recharge?${SerializeFilters(
      convertedFilters,
    )}`;
    return api.get(url, headers);
  };

  getNoRechargedTickets = (filters?: Filters): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters?.filters);
    const url = !convertedFilters
      ? 'api/pjtacom/ticket/no-charge/'
      : `api/pjtacom/ticket/no-charge/?${SerializeFilters(convertedFilters)}`;
    return api.get(url);
  };

  getTicketBillet = (code: any): AxiosPromise => {
    const url = `api/pjtacom/ticket/orders/${code}/billet/`;
    return api.get(url);
  };

  getDuplicateLetter = (code: string, date: string, name: string): AxiosPromise => {
    const url = `api/pjtacom/report/duplicate-letter?card-number=${code}&date=${date}&responsible=${name}`;
    return api.get(url, { responseType: 'arraybuffer' });
  };
}

export type { Relatorio };

export default TicketService;
